<template>
  <v-content>
    <v-container :fluid="this.$vuetify.breakpoint.mdAndDown">
      <v-card class="pa-4">
        <h1 class="display-3 secondary--text font-weight-bold pl-2">
          <!-- commenting out dynamic until admin page for about page is done
          {{ aboutPageData.pageTitle }} -->
          What is Resiliency?
        </h1>
        <p class="subheading pre-wrap">
          <!-- commenting out dynamic until admin page for about page is done
          {{ aboutPageData.introText }} -->
          Fort Meade has developed a resiliency campus with the goal of building
          strong, healthy service members, families and Department of Defense
          civilians. The mission is accomplished through a combination of
          military and civilian agencies that work together to provide hands on
          training and support in the five pillars of resiliency – Family,
          Emotional, Physical, Spiritual and Social.
        </p>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(shield, key) in SHIELDS"
            :key="key"
            class="clearfix"
          >
            <template v-slot:header>
              <h2 class="display-2 primary--text py-2">
                {{ shield.title }}
              </h2>
            </template>
            <v-container fluid>
              <v-layout row>
                <v-flex pa-1 lg10 class="subheading">
                  {{ shield.details }}
                  <br /><br />

                  {{ shield.listheader }}
                  <ul style="list-style: disc">
                    <li v-for="item in shield.list" :key="item">
                      {{ item }}
                    </li>
                  </ul>
                </v-flex>
                <v-flex pa-1 lg2>
                  <img
                    :src="require('../assets/' + shield.imgsrc)"
                    width="100%"
                    style="float: right, height: auto;"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!--
        <v-expansion-panel
          v-model="expansionPanelModel"
          expand
        >
          <v-expansion-panel-content
            v-for="(shield, key) in SHIELDS"
            :key="key"
            class="clearfix"
          >
            <template v-slot:header>
              <h2 class="display-2 primary--text py-2">
                {{ shield.title }}
              </h2>
            </template>
            <v-card flat>
              <v-card-text>
                <img
                  :src="require('../assets/' + shield.imgsrc)"
                  width="200px"
                  style="float: right"
                >
                <div class="subheading pre-wrap">

                  {{ shield.details }}

                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        -->
        <!-- Outro text -->
        <p class="subheading pre-wrap">
          The Fort Meade Resiliency Shield combines the individual shields that
          support the five pillars of resiliency and serves to assist the Fort
          Meade community in identifying resiliency programs and facilities
          throughout the installation. The combined shield was designed by the
          Fort Meade Alliance, in partnership with the Fort Meade Community
          Health Promotion Council.
        </p>
      </v-card>
    </v-container>
    <div style="height: 100px">
      <!--spacer to ensure back button doesn't cover up text-->
    </div>
    <div
      v-if="kioskMode"
      class="hidden-sm-and-down"
      style="position: fixed; bottom: 50px; left: 0; z-index: 10"
    >
      <fma-back-button />
    </div>
  </v-content>
</template>

<script>
import FmaBackButton from "@/components/FmaBackButton.vue";
import { SHIELDS } from "../constants";
import { mapState } from "vuex";

export default {
  components: {
    FmaBackButton
  },
  data() {
    return {
      expansionPanelModel: []
    };
  },
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode }),
    aboutPageData() {
      return this.$store.state.aboutPageData;
    },
    SHIELDS() {
      return SHIELDS;
    }
  },
  mounted() {
    this.$store.dispatch("fetchAboutPageData");
    this.expansionPanelModel = Object.keys(this.SHIELDS).map(
      val => `#${val}` === window.location.hash
    );
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

.pre-wrap {
  white-space: pre-wrap;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}
</style>
